import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dzs-icon",
  "use": "icon-dzs-icon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-dzs-icon\">\r\n  <path fill=\"currentColor\" d=\"M2.2 13.2h11.6a.6.6 0 0 1 0 1.2H2.2a.6.6 0 1 1 0-1.2Zm.4-1.6-.9-6.4a.6.6 0 0 1 1-.54l2.56 2.2 2.1-3.9a.6.6 0 0 1 1.06 0l2.1 3.9 2.56-2.2a.6.6 0 0 1 1 .54l-.9 6.4H2.6Zm1.04-1.2h8.72l.54-3.85-1.95 1.67a.6.6 0 0 1-.91-.16L8 4.77 5.96 8a.6.6 0 0 1-.9.16L3.1 6.49l.54 3.9Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dzs-icon.svg
// module id = /vG0
// module chunks = 115